<template>
  <b-row>
    <b-col cols="12">
      <clients-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ClientsTable from './ClientsTable.vue'

export default {
  components: {
    BRow,
    BCol,

    ClientsTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>